import {
    useMemo, useCallback,
    useState,
} from 'react'

import useLocalStorage, {
    LocalStorageKeys,
} from 'app/hooks/useLocalStorage'

import {
    AccordionItemType,
} from '../ReorderableAccordionItem'

const usePersistedOrderState = ({
    persistentKey,
    enablePersistence = true,
    initialItems,
}:{
    persistentKey: string,
    enablePersistence?: boolean,
    initialItems: AccordionItemType[],
}) => {
    const initState = useMemo(() => {
        return initialItems.map((table: AccordionItemType) => { return table.key })
    }, [initialItems])
    const {
        dataGridState,
        setDataGridState: setLocalState,
    } = useLocalStorage<string[]>({
        key: LocalStorageKeys.SKY_NET_ALL_ACCORDION_DASHBOARD_KEY,
        value: persistentKey,
        defaultValue: initState,
    })

    const [
        itemOrder,
        setItemOrder,
    ] = useState(initState)

    const onItemOrderChange = useCallback((newItems: AccordionItemType[]) => {
        const newOrder = newItems.map((table: AccordionItemType) => { return table.key })

        if (enablePersistence) {
            setLocalState(newOrder)
        } else {
            setItemOrder(newOrder)
        }
    }, [
        enablePersistence,
        setLocalState,
        setItemOrder,
    ])

    const orderState = useMemo(() => {
        if (enablePersistence) {
            if (!Array.isArray(dataGridState)) {
                return Object.values(dataGridState)
            }
            return dataGridState
        }
        return itemOrder
    }, [
        dataGridState,
        enablePersistence,
        itemOrder,
    ])

    const sortByItemOrderDelegate = useCallback((a: AccordionItemType, b: AccordionItemType) => {
        const indexA = orderState.indexOf(a.key)
        const indexB = orderState.indexOf(b.key)

        return indexA - indexB
    }, [orderState])

    return {
        onItemOrderChange,
        sortByItemOrderDelegate,
    }
}

export default usePersistedOrderState
